import { useContext } from "react";
import classnames from "classnames";
import { useSelector } from "react-redux";

import PromotionContext from "context/PromotionContext";
import { getCurrentDispensary } from "redux/selectors/dispensary";
import { trackMenuEvent } from "utils/trackEvent";

import PromoCard from "components/PromoCard";

const PromotionOverview: React.FC<{ className?: string }> = ({ className }) => {
  const { name, slug } = useSelector(getCurrentDispensary);

  const {
    selectors: { results },
  } = useContext(PromotionContext);

  if (!results || !results.length) {
    return null;
  }

  const trackSeeAllClick = () =>
    trackMenuEvent("Click", "See All Promotions Button");

  return (
    <div className={classnames(className)}>
      <div className="section__header">
        <h3 className="heading--m">{`Deals at ${name}`}</h3>
      </div>
      <div className="row">
        {/* eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: fix me please, do not replicate */}
        {results.slice(0, 3).map((item: any) => (
          <div className="lg:col-4 mb-md" key={item.id}>
            <PromoCard className="bg-leafly-white h-full" {...item} />
          </div>
        ))}
      </div>
      <a
        href={`/dispensary-info/${slug}/deals`}
        className="button mt-md"
        onClick={trackSeeAllClick}
        onKeyPress={trackSeeAllClick}
        role="button"
        tabIndex={0}
      >
        see all promotions
      </a>
    </div>
  );
};

export default PromotionOverview;
